<section
  class="sub-header fill white-text text-icon-reversed {{ backgroundColorClass() }}"
  [class.no-header]="noHeader()"
>
  <div class="grid-col-12 grid-max-width ps-xsmall-y flex flex--middle" [class.sub-header-wrapper]="staticHeight()">
    <section
      data-testid="sub-header-content"
      [ngClass]="{
        flex: actionButton(),
        'flex--middle': actionButton(),
        'col-1-10 sm-col-1-8 md-col-1-9': hasBasket(),
        'col-1-12': !hasBasket(),
      }"
    >
      @if (actionButton(); as action) {
        <div class="sub-header-action flex--nogrow flex flex--middle border-right pr-xxsmall-r ms-xxsmall-r">
          @if (isMobile()) {
            <fcom-icon-button
              data-testid="sub-header-action-button"
              [icon]="{ name: action.icon }"
              [size]="IconButtonSize.MEDIUM"
              [theme]="IconButtonTheme.DARK_TERTIARY_GHOST"
              [aria]="{ label: action.ariaLabel ?? action.label }"
              (clickBtn)="actionButtonClick.emit($event)"
            />
          } @else {
            <fcom-button
              data-testid="sub-header-action-button"
              [icon]="{ name: action.icon, position: IconPosition.LEFT }"
              [text]="action.label"
              [theme]="ButtonTheme.DARK_TERTIARY_GHOST"
              [aria]="{ label: action.ariaLabel ?? action.label }"
              (clickBtn)="actionButtonClick.emit($event)"
            />
          }
        </div>
      }
      <ng-content />
      @if (hasBasket() && cartButtonPositionLeft() && !isMobile()) {
        <div class="sub-header-button flex grow flex--middle flex--end ps-large-l">
          <ng-container [ngTemplateOutlet]="cartButton" />
        </div>
      }
    </section>
    @if (hasBasket() && (!cartButtonPositionLeft() || isMobile())) {
      <aside
        class="col-11-12 sm-col-9-12 md-col-10-12"
        data-testid="sub-header-basket"
        [class.border-left]="!showInfoIcon()"
      >
        <div class="sub-header-button flex grow flex--middle flex--end">
          <ng-container [ngTemplateOutlet]="cartButton" />
          @if ((showModifyButton$ | async) === true) {
            <button
              data-testid="modify-search"
              class="modify-button font-body-1 medium-type underline font-label-medium"
              (click)="changeStep.emit(STEPS.ENTRY)"
            >
              {{ 'services.sidebar.modifySearch' | finLocalization }}
            </button>
          }
        </div>
      </aside>
    }
  </div>
</section>
<ng-template #cartButton>
  @if (!shoppingCartEnabled && isMobile()) {
    <fcom-icon-button
      class="flex--nogrow"
      [attr.data-testid]="showInfoIcon() ? 'info-icon-button' : 'shopping-cart-icon-button'"
      [icon]="{
        name: showInfoIcon()
          ? SvgLibraryIcon.INFO_OUTLINE
          : isBasketDisabled() || !hasActiveBasketState()
            ? SvgLibraryIcon.SHOPPING_CART
            : SvgLibraryIcon.SHOPPING_CART_ACTIVE,
      }"
      [aria]="{
        label: 'bookingSummary.displayShoppingBasket' | finLocalization,
      }"
      [size]="IconButtonSize.MEDIUM"
      [theme]="IconButtonTheme.DARK_SECONDARY_OUTLINE"
      [disabled]="isBasketDisabled()"
      (clickBtn)="openBasket.emit()"
    />
  }
  @if (!showInfoIcon() && !isMobile() && !hasBasketActionInMobileOnly()) {
    <fcom-button
      class="flex--nogrow"
      (clickBtn)="openBasket.emit()"
      [icon]="{
        name:
          isBasketDisabled() || !hasActiveBasketState()
            ? SvgLibraryIcon.SHOPPING_CART
            : SvgLibraryIcon.SHOPPING_CART_ACTIVE,
        position: IconPosition.LEFT,
      }"
      [text]="'cart.title' | finLocalization"
      [theme]="ButtonTheme.DARK_SECONDARY_OUTLINE"
      [disabled]="isBasketDisabled()"
    />
  }
</ng-template>
